// helpers
import { makeActionCreator } from '../../../lib/Utils';

export const TOOLTIP_TOGGLE = 'TOOLTIP_TOGGLE';
export const toggleTooltip = makeActionCreator(TOOLTIP_TOGGLE, 'toggle');

export const TOOLTIP_HYDRATE = 'TOOLTIP_HYDRATE';
export const hydrateTooltip = makeActionCreator(TOOLTIP_HYDRATE, 'data');
